import { useNavigate } from "react-router-dom"
import FolderCard from "../shared/components/FolderCard"

const TestCards = [
  {
    route: "/dna-test",
    title: "🧬 Dna Test",
  },
  {
    route: "/blood-test",
    title: "🩸 Analisi degli Aminoacidi",
  },
]

const HolifyaTests = () => {
  const navigate = useNavigate()
  return (
    <div className="w-full h-full flex flex-col space-y-sm">
      {
        TestCards.map((card,index) => (
          <FolderCard key={`${card.title}-${index}`} onClick={() => navigate(card.route)} title={card.title}/>
        ))
      }
    </div>
  )
}

export default HolifyaTests
